module.exports = __webpack_public_path__ + "static/media/boxknight_logo.4a694afb.png";